import { HOUR_IN_MILLISECONDS } from 'utils/DateUtils';

import { DrugSpecificProtocol } from 'models/DrugSpecific';
import ScheduledProtocol from 'models/ScheduledProtocol';

import { defaultEndOptions } from 'views/Widgets/EndProtocolOptions';
import { intervalOptions } from 'views/Widgets/SymptomProtocolFields';

export const specificDrugTypeToLabelMap: Record<DrugSpecificProtocol, string> = {
  [DrugSpecificProtocol.Hourly]: 'Hourly',
  [DrugSpecificProtocol.WeeklyCRS]: 'Weekly (CRS)',
  [DrugSpecificProtocol.WeeklyInfection]: 'Weekly (Infection)',
  [DrugSpecificProtocol.WeeklyInfectionBiSpecific]: 'Ongoing Treatment Doses (Infection)',
  [DrugSpecificProtocol.SpecificTimesHourlyWithHospitalization]:
    'CRS Monitoring (With Hospitalization)',
  [DrugSpecificProtocol.SpecificTimesHourlyWithoutHospitalization]:
    'CRS Monitoring (Without Hospitalization)'
};

export const defaultDrugSpecificIntervalOptions = [
  ...intervalOptions,
  { value: HOUR_IN_MILLISECONDS, label: 'hour(s)' }
];

export const drugSpecificEndOptions = [
  ...defaultEndOptions,
  { value: ScheduledProtocol.END_TYPE_DURATION, label: 'Duration' }
];
